import React from "react"
import { Twitter, Envelope, Calendar } from "@images/icons"

const Footer = () => (
  <footer className="footer">
    <div className="wrapper footer__inner">
      <a
        href="https://twitter.com/alexmasmej"
        className="black-and-green"
        target="_blank"
        rel="noreferrer"
      >
        <Twitter /> Twitter
      </a>
      <a
        href="https://alexmasmej.substack.com/"
        className="black-and-green"
        target="_blank"
        rel="noreferrer"
      >
        <Envelope /> Newsletter
      </a>

      <a
        href="https://superpeer.com/alexm"
        className="black-and-green"
        target="_blank"
        rel="noreferrer"
      >
        <Calendar /> Book My Time
      </a>
    </div>

    <div className="footer__dev-links">
      <div className="wrapper">
        <p>
          Designed and developed by{" "}
          <a
            href="https://bighappytrees.github.io"
            target="_blank"
            rel="noreferrer"
          >
            BigHappyTrees
          </a>{" "}
          and{" "}
          <a
            href="https://www.tawneeallport.com/"
            target="_blank"
            rel="noreferrer"
          >
            Stormcloud266
          </a>
        </p>
      </div>
    </div>
  </footer>
)

export default Footer
